<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title class="mb-1">نمودار پراکندگی فعالیت کاربران</b-card-title>
        <!-- status -->
        <div class="d-flex align-items-center flex-wrap">
          <span
            class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer"
          ></span>
          <span class="mr-50">مشاهده کابران</span>

          <span
            class="bullet bullet-warning svg-font-small-3 mr-50 cursor-pointer"
          ></span>
          <span class="mr-50">فعالیت کاربران</span>
        </div>
        <!-- status -->
      </div>
      <!-- datepicker -->
      <div class=" ">
        <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
        <date-picker
          v-model="rangePick"
          autocomplete="on"
          :editable="false"
          id="created_at"
          name="created_at"
          class="form-control flat-picker bg-transparent border-0 shadow-none p-0"
          format="jYYYY-jMM-jDD"
        />
      </div>
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <template v-if="loading">
        <b-skeleton width="100%" height="500px"></b-skeleton>
      </template>
      <chartjs-component-bubble-chart
        v-else
        :height="500"
        :data="bubbleChart.data"
        :options="bubbleChart.options"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
import ChartjsComponentBubbleChart from "./ChartjsComponentBubbleChart.vue";
import flatPickr from "vue-flatpickr-component";

import { $themeColors } from "@themeConfig";
let moment = require("jalali-moment");

const chartColors = {
  primaryColorShade: "#836AF9",
  warningColorShade: "#ff9f43",
  warningLightColor: "##ff9f43",
  grid_line_color: "rgba(200, 200, 200, 0.2)",
};
export default {
  components: {
    BSkeleton,
    ChartjsComponentBubbleChart,
    BCard,
    BBadge,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
  data() {
    return {
      loading: false,
      statistics: [],
      rangePick: moment().locale("fa").format("YYYY-MM-DD"),
    };
  },
  watch: {
    rangePick(newValue) {
      if (newValue) (this.rangePick = newValue), this.getData();
    },
  },
  computed: {
    // rangePicker: {
    //   get: function () {
    //     return this.selectDate;
    //   },
    //   set: function (newValue) {
    //     !this.loading && ((this.selectDate = newValue), this.getData());
    //   },
    // },
    bubbleChart() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                ticks: {
                  stepSize: 1,
                  min: 0,
                  max: 24,
                  fontColor: chartColors.labelColor,
                  fontFamily: "IRANSans",
                },
              },
            ],
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: chartColors.grid_line_color,
                  zeroLineColor: chartColors.grid_line_color,
                },
                ticks: {
                  // stepSize: 100,
                  // min: 0,
                  // max: 400,
                  fontColor: chartColors.labelColor,
                  fontFamily: "IRANSans",
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            // Updated default tooltip UI
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: chartColors.tooltipShadow,
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
            titleFontFamily: "IRANSans",
            bodyFontFamily: "IRANSans",
            rtl: true,
          },
        },
        data: {
          animation: {
            duration: 10000,
          },
          datasets: [...this.datatest.audit, ...this.datatest.seen],
        },
      };
    },
    datatest() {
      return {
        audit: this.statistics.length
          ? this.statistics.map((item) => {
              return {
                backgroundColor: chartColors.warningColorShade,
                borderColor: chartColors.warningColorShade,
                data: [
                  {
                    x: moment(item.date).utc().format("HH"),
                    y: item.audit && item.audit.count ? item.audit.count : "",
                    r:
                      item.audit && item.audit.user_count
                        ? item.audit.user_count
                        : "",
                  },
                ],
              };
            })
          : [],
        seen: this.statistics.length
          ? this.statistics.map((item) => {
              return {
                backgroundColor: chartColors.primaryColorShade,
                borderColor: chartColors.primaryColorShade,
                data: [
                  {
                    x: moment(item.date).utc().format("HH"),
                    y:
                      item.seen_users &&
                      item.seen_users.count &&
                      item.seen_users.count,
                    r:
                      item.seen_users &&
                      item.seen_users.session_count &&
                      item.seen_users.session_count,
                  },
                ],
              };
            })
          : [],
      };
    },
  },
  methods: {
    async getData() {
      this.loading = true;
      let date = this.toGorgian(this.rangePick);
      try {
        const { data } = await this.$http.get("panel/dashboard/user-activity", {
          params: {
            date,
          },
        });
        this.statistics = data.data;
      } catch (e) {}
      this.loading = false;
    },
  },
  async created() {
    await this.getData();
  },
};
</script>
